import { MAXIMIZED, RESTORED } from '@/constants/windowConstants';
import { MAX_INTERACTION_WINDOWS_STATE } from '@/constants/store/constants';

const createInteractionWindow = (state, interactionWindow) => {
  state.windows.interaction.unshift(interactionWindow);
  if (state.windows.interaction.length > MAX_INTERACTION_WINDOWS_STATE) {
    state.windows.interaction = state.windows.interaction.slice(0, MAX_INTERACTION_WINDOWS_STATE);
  }
};

const updateInteractionWindow = (state, interactionWindow) => {
  // Find and update the interaction in place
  const windowIndex = state.windows.interaction.findIndex(
    window => window.interactionId === interactionWindow.interactionId
  );

  if (windowIndex !== -1) {
    state.windows.interaction.splice(windowIndex, 1, interactionWindow);
  }
};

const updateFocusedWindow = (state, interactionId) => (state.windows.focusedInteractionId = interactionId);

const updateFocusedElement = (state, elementId) => (state.windows.focusedElementId = elementId);

const clearFocusedWindows = state => (state.windows.focusedInteractionId = null);

const removeFocusedWindow = (state, interactionId) => {
  if (state.windows.focusedInteractionId === interactionId) {
    state.windows.focusedInteractionId = null;
  }
  // if there is only one more opened window, set focus to it.
  const visibleWindows = state.windows.interaction.filter(window =>
    [RESTORED, MAXIMIZED].includes(window.state.current)
  );
  if (visibleWindows.length >= 1) {
    state.windows.focusedInteractionId = visibleWindows[0].interactionId;
  }
};

const deleteInteractionWindow = (state, interactionId) => {
  state.windows.interaction = state.windows.interaction.filter(windows => windows.interactionId !== interactionId);
};

export default {
  createInteractionWindow,
  updateInteractionWindow,
  deleteInteractionWindow,
  updateFocusedWindow,
  removeFocusedWindow,
  clearFocusedWindows,
  updateFocusedElement
};
